import { Link } from '@tanstack/react-router';

import { formatLocalTime } from '@/lib/format';

import { overallState, useSyncState } from './controller';
import { SYNC_HASH } from './SyncPanel';

/**
 * One line in the footer, beside "Stored locally": whether the copy outside
 * this device is current. Silent when no folder is set. A lapsed permission
 * or a failure links to the panel that fixes it, because an unattended sync
 * cannot ask and would otherwise stop without anyone knowing.
 */
export function SyncStatusLine() {
  const all = useSyncState();
  const { phase, lastSyncAt } = overallState(all);
  const icloudExpired = all.icloud.phase === 'needs-permission';
  if (phase === 'off') {
    return null;
  }
  if (phase === 'needs-permission' || phase === 'error') {
    return (
      <Link to="/settings" hash={SYNC_HASH} className="text-danger underline underline-offset-2">
        {phase === 'error'
          ? 'Sync failed.'
          : icloudExpired
            ? 'iCloud sign-in required.'
            : 'Sync folder access required.'}
      </Link>
    );
  }
  if (phase === 'syncing') {
    return <span>Syncing.</span>;
  }
  return lastSyncAt === undefined ? null : <span>Synced {formatLocalTime(lastSyncAt)}.</span>;
}
